<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <b-card
            header-tag="header"
            footer-tag="footer">
            <div slot="header">
              <i class="fa fa-search-plus "></i><strong> Trazabilidad</strong>
              <div class="card-header-actions">
                  <small class="text-muted">-</small>
              </div>
            </div>
            <div>
              <b-row>
                  <b-col sm="6">
                  <b-form-select 
                  v-model="selectedTypeTracebility" 
                  :options="optionsTypeTracebility"
                  >
                  </b-form-select>
                  </b-col>
               </b-row>
                <br>


               <b-row v-if="selectedTypeTracebility==1">
                 
                 <b-col sm="6">
                    <v-select label="name"
                                placeholder="Buscar Pallet"
                                :filterable="false"
                                :options="options"
                                v-model="selected"
                                @search="onSearch"
                                @keypress.native="clearSelected"
                                @search:focus="clearSelected"
                                :clearable="false"
                                >
                        <template slot="no-options">
                        escribe para buscar pallets
                        </template>
                        <template slot="option" slot-scope="option">
                        <div class="d-center">
                        {{ option.number }} - {{option.container}}
                        </div>
                    </template>
                        <template slot="selected-option" slot-scope="option">
                        <div class="selected d-center">
                            {{ option.number }} - {{option.container}}
                        </div>
                        </template>
                     </v-select>
                 </b-col>
            </b-row>



               <div v-if="numPallerSearch && selectedTypeTracebility==1">
                 <br/>
      <h1>Detalle Pallet (<span>{{numPallerSearch}})</span></h1>
        <br/>

        
        <b-table striped
               hover
               small
               :fields="columns"
               :items="tableContentPallet"
               >


        <template v-slot:cell(Acciones)="data">
          <a
            target="_blank"
            href="#"
            title="Ver en detalle"
            @click.prevent="seeDetailContent(data.item)"
            class="fa fa-lg fa-search text-primary text-center"
          ></a>
           </template>

        <template v-slot:cell(actions)="data">
        <a href="#" @click.prevent="showReportLotProcess(props.row)"  class="fa fa-lg fa fa-file-excel-o text-black-50" title="Informe procesos"></a>&nbsp;
        </template>

        <template v-slot:cell(Variedad)="data">
          {{data.item.Variedad}} - {{data.item.condicion}}
        </template>

        <template v-slot:cell(+)="data">
          <p class="text-info" @click="data.toggleDetails">+</p>
        </template>

        <template v-slot:cell(fecha)="data">
          {{data.item.fecha | moment}}
        </template>

        <template v-slot:row-details="row">
          <b-card class="">
            <b-row class="mb-0">
              <b-col sm="3" class="text-sm-right"><b>Producto:</b></b-col>
              <b-col>{{ row.item.Producto }}</b-col>
            </b-row>
            <b-row class="mb-0">
              <b-col sm="3" class="text-sm-right"><b>Tipo de Producto:</b></b-col>
              <b-col>{{ row.item.Tipo_producto }}</b-col>
            </b-row>
            <b-row class="mb-0">
              <b-col sm="3" class="text-sm-right"><b>KN:</b></b-col>
              <b-col>{{ row.item.kilos_netos }}</b-col>
          </b-row>
          </b-card>

  </template>
      
      </b-table>


    </div>




            <b-row v-if="selectedTypeTracebility==2">
                 <b-col sm="6">
                    <v-select label="name"
                                placeholder="Buscar Lote"
                                :filterable="false"
                                :options="optionsLot"
                                v-model="selectedLot"
                                @search="onSearchLot"
                                @keypress.native="clearSelectedLot"
                                @search:focus="clearSelectedLot"
                                :clearable="false"
                                >
                        <template slot="no-options">
                        escribe para buscar lotes
                        </template>
                        <template slot="option" slot-scope="option">
                        <div class="d-center">
                        {{ option.number }} - {{option.product_name}} - {{option.variety_name}}
                        </div>
                    </template>
                        <template slot="selected-option" slot-scope="option">
                        <div class="selected d-center">
                        {{ option.number }} - {{option.product_name}} - {{option.variety_name}}
                        </div>
                        </template>
                     </v-select>
                 </b-col>
            </b-row>
             <br/>
                <div v-if="numLotSearch && selectedTypeTracebility==2">
                  <h1>Detalle Lote (<span>{{numLotSearch}})</span></h1>
                    <br/>
                    <b-table striped
                          hover
                          small
                          :fields="columnsLot"
                          :items="tableLot">
                    <template v-slot:cell(actions)="data">
                    <a href="#" @click.prevent="showReportLotProcess(data.item)"  class="fa fa-lg fa fa-file-excel-o text-black-50" title="Informe procesos"></a>&nbsp;
                    <a href="#" @click.prevent="showReportLotConsolidatedProcess(data.item)"  class="fa fa-lg fa fa-file-text-o text-black-50" title="Informe consolidado castaña"></a>&nbsp;
                    </template>
                  </b-table>
                </div>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </div>

    

      <b-modal
         ref="reportModalLotProcess"
         centered size="xl"
         title="Reporte lote proceso"
         ok-only
        >

        <div class="text-center">
        <b-spinner v-if="loading" label="Spinning"></b-spinner>
       </div>

         <component :is="componenteActual" :process="process" :processConsolidated="processConsolidated" :numLotSearch="numLotSearch"></component>

        </b-modal> 


  </div>

</template>



<script>

  import Vue from 'vue'
  import {ClientTable, Event} from 'vue-tables-2'
  import vSelect from 'vue-select'
  import 'vue-select/dist/vue-select.css';
  import moment from 'moment'
  import ReportLoteProceso from './ReportLotProcess.vue'
  import ReportLoteConsolidatedProceso from './ReportLotConsolidatedProcess.vue'

 
 
  Vue.use(ClientTable);




export default {
  name: 'MainTraceability',
   components: {
      vSelect,
      ReportLoteProceso,
    },
  created () {
  },
  data () {
    return {
     process: [],
     processConsolidated: [],
     loading: false,
     componenteActual: '',
     selected: null,
     options: [],
     selectedLot: "",
     optionsLot: [],
     items: [],
     numPallerSearch:false,
     tableContentPallet:[],
     perPage: 5,
        currentPage: 1,
        columns: [
          // "Producto",
          // "Tipo_producto",
          "+",
          "Variedad",
          "Origen",
          {
            key: 'planta',
            label: 'Planta',
            formatter: (value, key, item) => {
              return value ? value.name : '-'
            },
            sortable: true,
            sortByFormatted: true,
            filterByFormatted: true
          },
          "planta",
          "fecha",

          // "kilos_netos",
          "formato",
          "Especificaciones",
          "Cantidad",
         // "Existe",
          "Acciones"
        ],
        selectedTypeTracebility: null,
        optionsTypeTracebility: [
          { value: null, text: 'Seleccione' },
          { value: '1', text: 'Busqueda por pallet' },
          { value: '2', text: 'Busqueda por lote' }
        ],
        numLotSearch:false,
        tableLot:[],
          columnsLot: [
          // 'id',
          'Numero',
          'Guia',
          'Productor',
          'Producto',
          'Variedad',
          'actions',
        ],
    }
  }, 
 filters: {
      moment(value) {
        return moment(value).format('DD-MM-YYYY')
      }
    },
    watch: {
        selected: function (obj) {

          this.numPallerSearch=obj.number;

            if(obj.id != null)
            {
                this.tableContentPallet = [];

                this.$axios
                .get(
                  "/api/v1/allstock/" + obj.id + "/get_all_content_pallet/"
                )
                .then(res => {

                        const datos = res.data.data;

                        for (let key in datos) {

                          var rowNew = {
                            Producto: datos[key].variety.product.name,
                            Tipo_producto: datos[key].product_type.name,
                            Variedad: datos[key].variety.name,
                            Origen: datos[key].origin.name,
                            kilos_brutos: datos[key].gross_kilograms,
                            kilos_netos: datos[key].net_kilograms,
                            Cantidad: datos[key].quantity,
                            Especificaciones: datos[key].specifications,
                            IDContenido: datos[key].id,
                            formato: datos[key].container.name,
                            condicion: datos[key].condition,
                            fecha: datos[key].creation_date,
                            planta: datos[key].plant,
                          //  Existe: datos[key].status_content== true ? "Si" : "No",
                            pallet_number:datos[key].pallet_number,
                          

                          };

                          this.tableContentPallet.push(rowNew);
              } 

            })
            .catch(error => console.log(error.message));



            }

        },
         selectedLot: function (obj) {

          this.numLotSearch=obj.number;
          

            if(obj.id != null)
            {
            
                this.tableLot = [];

                  var rowNew = {
                            IdLote: obj.id,
                            Numero: obj.number,
                            Guia: obj.waybill_number,
                            Productor: obj.origin_name,
                            Producto: obj.product_name,
                            Variedad: obj.variety_name
                          };

                this.tableLot.push(rowNew);


            }

        }

    },
    methods: {
       getBadge (existe) {
          return existe === "Si" ? 'success' : 'danger';
        },
        onSearch(search, loading) {
        loading(true);
        this.search(loading, search, this);
      },
      search: _.debounce((loading, search, vm) => {
          vm.$axios.get (`/api/v1/pallet/all_traceability_pallets/?q=${escape(search)}`)
          .then(res => {
            vm.options = res.data;
            loading(false);
          })
        .catch(error => {
          console.log(error.response)
        });
      }, 350),
      clearSelected(){
        this.selected="";
        this.tableContentPallet = [];
        this.options = [];
      },
      seeDetailContent(row){
        
       this.$router.push("/trazabilidad/detailed/"+this.selected.id+"/"+row.IDContenido+"/"+row.pallet_number);
      },
       onSearchLot(search, loading) {
        loading(true);
        this.searchLot(loading, search, this);
      },
      searchLot: _.debounce((loading, search, vm) => {
          vm.$axios.get (`/api/v1/lot/get_traceability_lots/?q=${escape(search)}`)
          .then(res => {
            vm.optionsLot = res.data;
            loading(false);
          })
        .catch(error => {
          console.log(error.response)
        });
      }, 350),
      clearSelectedLot(){
       this.selectedLot="";
       this.tableLot = [];
       this.optionsLot = [];
      },
      showReportLotProcess(row){
        this.loading = true;
          this.$nextTick(function () {
            this.getLotProcess(row.IdLote);
            });
            this.$refs.reportModalLotProcess.show();
      },
      getLotProcess(lot_id) {
           this.$axios.get ('/api/v1/lot/'+lot_id+'/detailed_lote_with_traceability/')
          .then(res => {
            this.process = res.data.data;
            this.loading = false;
            this.componenteActual=ReportLoteProceso;
          })
          .catch(error => console.log(error)) 
        },
      showReportLotConsolidatedProcess(row){
        this.loading = true;
          this.$nextTick(function () {
            this.getLotConsolidatedProcess(row.IdLote);
            });
            this.$refs.reportModalLotProcess.show();
      },
      getLotConsolidatedProcess(lot_id) {
        
          this.$axios.get ('/api/v1/lot/'+lot_id+'/detailed_lote_especification/')
          .then(res => {
            this.processConsolidated = res.data.data;
            this.loading = false;
          })
          .catch(error => console.log(error)) 


           this.$axios.get ('/api/v1/lot/'+lot_id+'/detailed_lote_with_traceability/')
          .then(res => {
            this.process = res.data.data;
            this.loading = false;
            this.componenteActual=ReportLoteConsolidatedProceso;
          })
          .catch(error => console.log(error))

        },
  },
      mounted(){
    }

}

</script>


<style>
  .style-chooser .vs__search::placeholder,
  .style-chooser .vs__dropdown-toggle,
  .style-chooser .vs__dropdown-menu {
    /*display: inline-block;*/
    /*width: 100%;*/
    min-height: calc(1.5em + 0.75rem + 2px);
    /*padding: 0.375rem 1.75rem 0.375rem 0.75rem;*/
    font-size: 0.6875rem;
    font-weight: 400;
    /*line-height: 1.5;*/
    color: #5c6873;
    /*vertical-align: middle;*/
    /*background-color: #fff;*/
    border: 1px solid #e4e7ea;
    /*border-radius: 0.25rem;*/
    /*-webkit-appearance: none;*/

  }

  .style-chooser .vs__clear,
  .style-chooser .vs__open-indicator {
    fill: #394066;
  }


  img {
    height: auto;
    max-width: 2.5rem;
    margin-right: 1rem;
  }

  .d-center {
    display: flex;
    align-items: center;
  }

  .selected img {
    width: auto;
    max-height: 23px;
    margin-right: 0.5rem;
  }

  .v-select .dropdown li {
    border-bottom: 1px solid rgba(112, 128, 144, 0.1);
  }

  .v-select .dropdown li:last-child {
    border-bottom: none;
  }

  .v-select .dropdown li a {
    padding: 10px 20px;
    width: 100%;
    font-size: 1.25em;
    color: #3c3c3c;
  }

  .v-select .dropdown-menu .active > a {
    color: #fff;
  }


</style>